export default __webpack_public_path__ + "static/media/image.276d2166.png";